/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendResetMailRequest
 */
export interface SendResetMailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendResetMailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the SendResetMailRequest interface.
 */
export function instanceOfSendResetMailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function SendResetMailRequestFromJSON(json: any): SendResetMailRequest {
    return SendResetMailRequestFromJSONTyped(json, false);
}

export function SendResetMailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendResetMailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function SendResetMailRequestToJSON(value?: SendResetMailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

